module.exports = __webpack_public_path__ + "7370505a3af90c84961db68c4d6ef1bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/vertex_pharmaceuticals.png
// module id = 2068
// module chunks = 0